<template>
    <div>
        <div class="wrapper">
            <div class="col12 pt-0">
                <h1 class="page_title">まもりこサービス対応機器「人感センサー」購入のお申し込み</h1>
                <div class="signup_flow">
                    <ol>
                        <li><span>1</span>ログ <br class="on-sp" />イン</li>
                        <li><span>2</span>申込 <br class="on-sp" />内容</li>
                        <li class="current"><span>3</span>情報 <br class="on-sp" />入力</li>
                        <li><span>4</span>支払</li>
                        <li><span>5</span>完了</li>
                    </ol>
                </div>
                <!-- signup_flow -->
            </div>
        </div>
        <!-- wrapper -->

        <section class="container">
            <div class="wrapper">
                <h2 class="col5 section_title">
                    <strong>お申込み内容の確認</strong>
                </h2>
                <div class="col7 wrap_pr_2col input_area">
                    <h4 class="application_name">お支払い金額</h4>
                    <h3 class="strong big-16 mb-05em">初期費用</h3>
                    <ul class="default_list local">
                        <li>
                            <span>価格</span>
                            <span>&yen;{{ formatCommafy((product.init && product.init.plans[0].amount) || 0) }}</span>
                        </li>
                        <li>
                            <span class="under_line">クーポン利用</span>
                            <span class="under_line">
                                <div v-if="discountInit > 0">&yen;-{{ formatCommafy(discountInit) }}</div>
                                <div v-else>-</div>
                            </span>
                        </li>
                        <li>
                            <span>合計</span>
                            <span>&yen;{{ formatCommafy(((product.init && product.init.plans[0].amount) || 0) - discountInit) }}-(税込)</span>
                        </li>
                    </ul>

                    <p class="submit_btn no-check arrow-back">
                        <a href="javascript:void(0)" @click="modifyContent('CouponForm')">修正する</a>
                    </p>

                    <hr class="thick" />

                    <template v-if="!isLogin">
                        <h4 class="application_name">メールアドレス</h4>
                        <dl>
                            <dt>メールアドレス</dt>
                            <dd>{{ customerEmail }}</dd>
                        </dl>
                        <p class="submit_btn no-check arrow-back">
                            <a href="javascript:void(0)" @click="modifyContent('ContractForm')">修正する</a>
                        </p>
                        <hr class="thick" />
                    </template>

                    <h4 class="application_name">契約者情報</h4>
                    <dl>
                        <dt>お名前</dt>
                        <dd>{{ customerName }}</dd>
                    </dl>
                    <dl>
                        <dt>フリガナ</dt>
                        <dd>{{ customerKana ? customerKana : "(入力なし)" }}</dd>
                    </dl>
                    <dl>
                        <dt>郵便番号</dt>
                        <dd>{{ customerPostalCode }}</dd>
                    </dl>
                    <dl>
                        <dt>都道府県</dt>
                        <dd>{{ customerPrefecture }}</dd>
                    </dl>
                    <dl>
                        <dt>ご住所</dt>
                        <dd>{{ customerCity }}{{ customerAddress }}</dd>
                    </dl>
                    <dl>
                        <dt>電話番号</dt>
                        <dd>{{ customerTel }}</dd>
                    </dl>
                    <p class="submit_btn no-check arrow-back">
                        <a href="javascript:void(0)" @click="modifyContent('ContractForm')">修正する</a>
                    </p>

                    <hr class="thick" />

                    <h4 class="application_name">配送先情報</h4>
                    <div v-show="copyAddress">
                        <dl>
                            <dd>契約者と同じ住所に配送する</dd>
                        </dl>
                    </div>
                    <div v-show="!copyAddress">
                        <dl>
                            <dt>お名前</dt>
                            <dd>{{ destinationName }}</dd>
                        </dl>
                        <dl>
                            <dt>フリガナ</dt>
                            <dd>{{ destinationKana ? destinationKana : "(入力なし)" }}</dd>
                        </dl>
                        <dl>
                            <dt>郵便番号</dt>
                            <dd>{{ destinationPostalCode }}</dd>
                        </dl>
                        <dl>
                            <dt>都道府県</dt>
                            <dd>{{ destinationPrefecture }}</dd>
                        </dl>
                        <dl>
                            <dt>ご住所</dt>
                            <dd>{{ destinationCity }}{{ destinationAddress }}</dd>
                        </dl>
                        <dl>
                            <dt>電話番号</dt>
                            <dd>{{ destinationTel }}</dd>
                        </dl>
                    </div>
                    <!-- add_info -->
                    <p class="submit_btn no-check arrow-back">
                        <a href="javascript:void(0)" @click="modifyContent('ContractForm')">修正する</a>
                    </p>

                    <hr class="thick" />
                    <!-- <h4 class="application_name">お届け日の指定</h4>
          <dl>
            <dt>お届け日時</dt>
            <dd>{{deliveryDateLabel}}{{deliveryTimeLabel}}</dd>
          </dl>
          <p class="submit_btn no-check arrow-back">
            <a href="javascript:void(0)" @click="modifyContent('EnqueteForm')">修正する</a>
          </p>

          <hr class="thick" /> -->

                    <dl>
                        <dd class="break-all">お申込み完了後のキャンセル・返品・解約について</dd>
                    </dl>
                    <dl>
                        <dd class="break-all">
                            ・商品到着後7日以内であれば、新品未開封の場合に限り、お問合せフォーム等によりご連絡（※１）いただくことで返品を承ります。返送費用はお客様負担となります。
                        </dd>
                    </dl>
                    <dl>
                        <dd class="break-all">
                            ・本商品は LTE 通信を利用しています。開封後であっても電波条件によりご利用できない場合には、サービス利用開始日 ( 商品到着日 ) より 7
                            日以内にお問合せフォーム等によりご連絡（※１）いただくことで、返品を承ります。
                        </dd>
                    </dl>
                    <dl>
                        <dd class="break-all">※１　お問合せ窓口：（WEB）https://www.necolico.co.jp/contact/support_mamolico/（電話）03-5205-4468</dd>
                    </dl>

                    <p class="submit_btn">
                        <input type="submit" value="この内容で申し込む" @click="confirm" />
                    </p>
                    <p class="submit_btn no-check no-arrow mt-3em">
                        <a href="javascript:void(0)" @click="cancel">キャンセル</a>
                    </p>
                </div>
                <!-- wrap_pr_2col input_area -->
            </div>
            <!-- wrapper -->
        </section>
        <!-- container -->
    </div>
</template>

<script>
export default {
    beforeRouteEnter(to, from, next) {
        // 特定の画面以外からの遷移は禁止
        if (from.name !== "ContractForm") {
            next("/login");
            return;
        }
        next();
    },
    beforeRouteLeave(to, from, next) {
        // 「入力内容を修正」ボタンや、ブラウザで戻られた場合に、入力項目を復元する
        to.params.customerName = this.customerName;
        to.params.customerKana = this.customerKana;
        to.params.customerPostalCode = this.customerPostalCode;
        to.params.customerPrefecture = this.customerPrefecture;
        to.params.customerCity = this.customerCity;
        to.params.customerAddress = this.customerAddress;
        to.params.customerTel = this.customerTel;
        to.params.customerEmail = this.customerEmail;
        to.params.copyAddress = this.copyAddress;
        to.params.destinationName = this.destinationName;
        to.params.destinationKana = this.destinationKana;
        to.params.destinationPostalCode = this.destinationPostalCode;
        to.params.destinationPrefecture = this.destinationPrefecture;
        to.params.destinationCity = this.destinationCity;
        to.params.destinationAddress = this.destinationAddress;
        to.params.destinationTel = this.destinationTel;
        to.params.searchedCustomerPostalCode = this.searchedCustomerPostalCode;
        to.params.searchedDestinationPostalCode = this.searchedDestinationPostalCode;
        to.params.searchedCustomerAddressInfoEmpty = this.searchedCustomerAddressInfoEmpty;
        to.params.searchedDestinationAddressInfoEmpty = this.searchedDestinationAddressInfoEmpty;
        to.params.cards = this.cards;
        to.params.card = this.card;
        to.params.isRequiredCredit = this.isRequiredCredit;

        to.params.product = this.product;
        to.params.code = this.code;
        to.params.promotionCode = this.promotionCode;

        to.params.invoiceNo = this.invoiceNo;

        next();
    },
    methods: {
        formatDateCustom: function (date, format) {
            return this.$utils.formatDate(date, format);
        },
        formatDate: function (date) {
            return this.$utils.formatDate(date, "yyyy/MM/dd");
        },
        formatCommafy: function (val) {
            return this.$utils.commafy(val);
        },

        modifyContent: async function (pagaName) {
            // パラメータはbeforeRouteLeaveで設定
            this.$router.push({
                name: pagaName
            });
        },

        confirm: function () {
            if (this.isRequiredCredit) {
                this.$router.push({
                    name: "Payment"
                });
                return;
            } else {
                // 0円クーポン適用でクレジットカードが不要の場合、この画面が申し込み完了前の最終ページになるので確認ダイアログを表示する
                this.$emit(
                    "openConfirmYesModal",
                    "この内容で申し込みをしてもよろしいですか？ボタン押下後はブラウザの「戻る」ボタンや「更新」ボタンを押さないでください。",
                    async () => {
                        this.complete();
                    },
                    () => {
                        // いいえの場合は処理しない
                        return;
                    }
                );
            }
        },
        complete: function () {
            this.$emit("showSpinner", "処理中です。処理中はブラウザの「戻る」ボタンや「更新」ボタンを押さないでください。");
            this.$axios(
                "POST",
                "/contractConfirm/order",
                {
                    customer: {
                        name: this.customerName,
                        kana: this.customerKana,
                        ageGroup: this.ownerAgeGroup,
                        gender: this.ownerGender,
                        postalCode: this.customerPostalCode,
                        prefecture: this.customerPrefecture,
                        city: this.customerCity,
                        address: this.customerAddress,
                        tel: this.customerTel,
                        email: this.customerEmail
                    },
                    destination: {
                        name: this.copyAddress ? this.customerName : this.destinationName,
                        kana: this.copyAddress ? this.customerKana : this.destinationKana,
                        postalCode: this.copyAddress ? this.customerPostalCode : this.destinationPostalCode,
                        prefecture: this.copyAddress ? this.customerPrefecture : this.destinationPrefecture,
                        city: this.copyAddress ? this.customerCity : this.destinationCity,
                        address: this.copyAddress ? this.customerAddress : this.destinationAddress,
                        tel: this.copyAddress ? this.customerTel : this.destinationTel
                    },
                    card: this.card,

                    product: this.product,
                    productId: document.productId,
                    code: this.code,
                    promotionCode: this.promotionCode,

                    np: document.np,

                    deliveryDate: this.deliveryDate,
                    deliveryTime: this.deliveryTime
                },
                // eslint-disable-next-line no-unused-vars
                (res) => {
                    this.$emit("hideSpinner");
                    // 申し込みフォーム画面へ遷移
                    this.invoiceNo = res.data.invoiceNo;
                    this.$router.push({
                        name: "ContractComplete"
                    });
                }
            );
        },
        cancel: function () {
            this.$emit("openConfirmModal", "申込みをキャンセルしますか？", () => {
                // TOP画面へ遷移
                this.$router.push({
                    name: "Top",
                    params: {}
                });
            });
        }
    },
    data: function () {
        return {
            customerName: "",
            customerKana: "",
            customerPostalCode: "",
            customerPrefecture: "",
            customerCity: "",
            customerAddress: "",
            customerTel: "",
            customerEmail: "",
            copyAddress: true,
            destinationName: "",
            destinationKana: "",
            destinationPostalCode: "",
            destinationPrefecture: "",
            destinationCity: "",
            destinationAddress: "",
            destinationTel: "",
            searchedCustomerPostalCode: false,
            searchedDestinationPostalCode: false,
            searchedCustomerAddressInfoEmpty: false,
            searchedDestinationAddressInfoEmpty: false,
            cards: [],
            card: undefined,
            isRequiredCredit: true,
            beforeSource: null,
            product: {},
            ownerGender: "",
            ownerGenderLabel: "",
            ownerAgeGroup: "",
            discountInit: 0,
            invoiceNo: "",
            isLogin: !document.isWithoutLogin
        };
    },
    created() {
        // サービス料金
        this.product = this.$route.params.product;
        this.code = this.$route.params.code;
        this.promotionCode = this.$route.params.promotionCode;
        //  会員情報
        this.customerName = this.$route.params.customerName;
        this.customerKana = this.$route.params.customerKana;
        this.customerPostalCode = this.$route.params.customerPostalCode;
        this.customerPrefecture = this.$route.params.customerPrefecture;
        this.customerCity = this.$route.params.customerCity;
        this.customerAddress = this.$route.params.customerAddress;
        this.customerTel = this.$route.params.customerTel;
        this.copyAddress = this.$route.params.copyAddress;
        this.cards = this.$route.params.cards;
        this.card = this.$route.params.card;
        this.isRequiredCredit = this.$route.params.isRequiredCredit;
        this.customerEmail = this.$route.params.customerEmail;
        // 配送先
        this.destinationName = this.$route.params.destinationName;
        this.destinationKana = this.$route.params.destinationKana;
        this.destinationPostalCode = this.$route.params.destinationPostalCode;
        this.destinationPrefecture = this.$route.params.destinationPrefecture;
        this.destinationCity = this.$route.params.destinationCity;
        this.destinationAddress = this.$route.params.destinationAddress;
        this.destinationTel = this.$route.params.destinationTel;

        this.searchedCustomerPostalCode = this.$route.params.searchedCustomerPostalCode;
        this.searchedDestinationPostalCode = this.$route.params.searchedDestinationPostalCode;

        this.searchedCustomerAddressInfoEmpty = this.$route.params.searchedCustomerAddressInfoEmpty;
        this.searchedDestinationAddressInfoEmpty = this.$route.params.searchedDestinationAddressInfoEmpty;

        // 配送情報
        // this.deliveryDate = this.$route.params.deliveryDate;
        // this.deliveryDateLabel = this.$route.params.deliveryDateLabel;
        // this.deliveryTime = this.$route.params.deliveryTime;
        // this.deliveryTimeLabel = this.$route.params.deliveryTimeLabel;

        // 割引額の計算(小数第一位を四捨五入)
        if (this.promotionCode.init && this.promotionCode.init.percentOff) {
            this.discountInit = Math.round((this.product.init.plans[0].amount * this.promotionCode.init.percentOff) / 100);
        } else if (this.promotionCode.init && this.promotionCode.init.amountOff) {
            this.discountInit = this.promotionCode.init.amountOff;
        }
    }
};
</script>
<style scoped>
label > img {
    width: 100px;
    height: auto;
}

.break-all {
    word-break: break-all;
}
</style>
